"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DASHBOARD_PERIOD_LABELS = exports.DEFAULT_DASHBOARD_PERIOD = exports.DASHBOARD_PERIODS = void 0;
exports.isDashboardPeriod = isDashboardPeriod;
exports.parseDashboardPeriod = parseDashboardPeriod;
exports.resolveDashboardPeriodDays = resolveDashboardPeriodDays;
exports.resolveDashboardComparisonPeriod = resolveDashboardComparisonPeriod;
exports.dashboardPeriodToActivityPeriod = dashboardPeriodToActivityPeriod;
exports.DASHBOARD_PERIODS = ['7d', '30d', '90d', 'all'];
exports.DEFAULT_DASHBOARD_PERIOD = '30d';
exports.DASHBOARD_PERIOD_LABELS = {
  '7d': 'Last 7 days',
  '30d': 'Last 30 days',
  '90d': 'Last 90 days',
  all: 'All time'
};
function isDashboardPeriod(value) {
  return value != null && exports.DASHBOARD_PERIODS.includes(value);
}
function parseDashboardPeriod(value) {
  return isDashboardPeriod(value) ? value : exports.DEFAULT_DASHBOARD_PERIOD;
}
function resolveDashboardPeriodDays(period) {
  switch (period) {
    case '7d':
      return 7;
    case '30d':
      return 30;
    case '90d':
      return 90;
    case 'all':
      return null;
  }
}
function resolveDashboardComparisonPeriod(period) {
  switch (period) {
    case '7d':
      return 'week';
    case '30d':
      return 'month';
    case '90d':
      return 'quarter';
    case 'all':
      return 'none';
  }
}
/** Maps dashboard period to venue-activity / user-interactions query param values. */
function dashboardPeriodToActivityPeriod(period) {
  switch (period) {
    case '7d':
      return '7d';
    case '30d':
      return '30d';
    case '90d':
      return '90d';
    case 'all':
      return undefined;
  }
}
//# sourceMappingURL=dashboard-period.js.map